import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { PanelsSubmission } from "../../shared/interfaces/SurveyableAsset";

export function useAddPanelsToSwitchgear(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["addPanelsToExistingSwitchgear"],
    async (panelSubmission: PanelsSubmission) =>
      apiContext.hvSubstationApis.addHvSurveyableChildAssetsToExistingSurveyableAsset(panelSubmission),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
